import React, { useEffect, useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";

import Row from "./Row";

const Table = ({ data, className, activeTable, setActiveTable }) => {
  const [activeId, setActiveId] = useState();

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [tableData, setTableData] = useState(data);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  const handleChange = (id) => {
    if (selectedFilters.includes(id)) {
      setSelectedFilters(selectedFilters.filter((x) => x !== id));
    } else {
      setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
    }
  };
  const handleDelete = (deletedId) => {
    setTableData(prevData => prevData.filter(item => item.id !== deletedId));
  };
  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, { [styles.active]: activeTable })}>
          <div className={styles.col}>Tag</div>
          <div className={styles.col}>Description</div>

          <div className={styles.col}>Created By</div>
          <div className={styles.col}>Created On</div>
          <div className={styles.col}>Status</div>
        </div>
        {tableData?.map((role, index) => (
          <Row
            item={role}
            key={role.id}
            activeTable={activeTable}
            setActiveTable={setActiveTable}
            activeId={activeId}
            setActiveId={setActiveId}
            value={selectedFilters.includes(role.id)}
            onChange={() => handleChange(role.id)}
            onDelete={handleDelete}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
